import type { LayerState } from '@vitals/shared';
import { LAYER_DOT_SPEEDS } from '@vitals/shared';
import type { VitalDef, VitalTone } from './vitals.js';

/** TomTom low-zoom NYC corridor pulse. The optional detailed map layer is
 * independently controlled by the eye button bound in panel.ts. */
export const speedVital: VitalDef = {
  id: 'speed',
  layerId: LAYER_DOT_SPEEDS,

  select(s: LayerState | undefined): ReturnType<VitalDef['select']> {
    const down = !s || s.status === 'down' || s.summary == null;
    const stale = s?.status === 'stale';

    if (down) {
      return {
        value: '—',
        label: 'traffic',
        down: true,
        stale,
      };
    }

    const summary = s.summary as { category?: unknown };
    const category = typeof summary.category === 'string' &&
      ['clear', 'building', 'slow', 'jammed'].includes(summary.category)
      ? summary.category
      : null;
    if (!category) return { value: '—', label: 'traffic', down: true, stale };
    const tone: VitalTone = category === 'clear' ? 'good' : category === 'jammed' ? 'bad' : 'warn';
    const displayCategory = category[0]!.toUpperCase() + category.slice(1);

    return {
      value: displayCategory,
      label: 'traffic',
      down: false,
      stale,
      tone,
    };
  },
};
